import { render } from "./WSpinner.vue?vue&type=template&id=65b51596&ts=true"
import script from "./WSpinner.vue?vue&type=script&lang=ts"
export * from "./WSpinner.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__